var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployee7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#88EBBD",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4421 15.172V17.09H13.4381V19.162H16.4341V21.024H13.4381V25H11.0441V15.172H17.4421ZM29.9703 15.172V25H27.5763V19.106L25.3783 25H23.4463L21.2343 19.092V25H18.8403V15.172H21.6683L24.4263 21.976L27.1563 15.172H29.9703Z",
    fill: "#88EBBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee7);
export default __webpack_public_path__ + "static/media/employee7.b52c0d95d544e8571d6fca31e7977cc3.svg";
export { ForwardRef as ReactComponent };